import {useState} from 'react';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {PrivateIp} from '../../Types/routerForms';
import {useAddPrivateIp, useRemovePrivateIp} from '../../Hooks/RouterManager';
import AddPrivateIpModal from './AddPrivateIpModal';
import ActionIcon from '../../../../Components/ActionIcon';
import Level3Title from '../../../../app/common/components/title/Level3Title';

const MAX_PRIVATE_IPS = 3;

interface PrivateIpsSectionProps {
  routerId: string;
  ips: PrivateIp[];
}

const PrivateIpsSection = ({routerId, ips}: PrivateIpsSectionProps): JSX.Element => {
  const intl = useIntl();
  const [showAdd, setShowAdd] = useState(false);
  const addIp = useAddPrivateIp(routerId);
  const removeIp = useRemovePrivateIp(routerId);

  const handleAdd = (ip: PrivateIp) => addIp.mutate({address: ip.address, mask: ip.mask});

  const handleDelete = (id: string) => {
    if (
      window.confirm(
        intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.CONFIRM_DELETE'})
      )
    ) {
      removeIp.mutate(id);
    }
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title
            title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.TITLE'})}
          />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <table className="table table-row-dashed align-middle">
          <thead>
            <tr className="fw-semibold text-muted">
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.IP'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.MASK'})}</th>
              <th style={{width: 60}}></th>
            </tr>
          </thead>
          <tbody>
            {ips.length === 0 && (
              <tr>
                <td colSpan={3} className="text-muted text-center">
                  {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.EMPTY'})}
                </td>
              </tr>
            )}
            {ips.map((ip) => (
              <tr key={ip.id}>
                <td>{ip.address}</td>
                <td>{ip.mask}</td>
                <td>
                  <ActionIcon
                    label={intl.formatMessage({id: 'COMMON.DELETE'})}
                    faIcon="fa-solid fa-trash text-danger"
                    onClick={() => handleDelete(ip.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {ips.length < MAX_PRIVATE_IPS && (
          <button className="btn btn-light btn-sm" onClick={() => setShowAdd(true)}>
            <i className="fa-solid fa-plus me-2" />
            {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.PRIVATE_IPS.ADD'})}
          </button>
        )}
        <AddPrivateIpModal show={showAdd} onHide={() => setShowAdd(false)} onAdd={handleAdd} />
      </Card.Body>
    </Card>
  );
};

export default PrivateIpsSection;
